<div class="radarchart-container"
  style="position: relative; height:280px; width:100%">
  <canvas #canvasItem height="280"></canvas>
</div>
